module KendoWidgets
{
	export class ArcGaugeOptions implements kendo.dataviz.ui.ArcGaugeOptions
	{
		name?: string;
		centerTemplate?: string | Function;
		color?: string;
		colors?: kendo.dataviz.ui.ArcGaugeColor[];
		gaugeArea?: kendo.dataviz.ui.ArcGaugeGaugeArea;
		opacity?: number;
		renderAs?: string;
		scale?: kendo.dataviz.ui.ArcGaugeScale;
		theme?: string;
		transitions?: boolean;
		value?: number;
	}

	export class ArcGauge extends kendo.dataviz.ui.ArcGauge implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.ArcGauge; }

		constructor(element: Element, options?: KendoWidgets.ArcGaugeOptions)
		{
			if (options == null)
				options = new KendoWidgets.ArcGaugeOptions();


			super(element, options);
		}

		//#region Append
		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.prependTo(element);
		}
		//#endregion
	}

	ArcGauge.fn = ArcGauge.prototype;
	ArcGauge.fn.options = $.extend(true, {}, kendo.dataviz.ui.ArcGauge.fn.options);
	ArcGauge.fn.options.name = "ArcGauge";
	kendo.ui.plugin(ArcGauge);
}

interface JQuery
{
	kendoArcGauge(options?: KendoWidgets.ArcGaugeOptions): JQuery;
}